import { type ReactElement } from 'react';
import FeaturePageLayout from '../../components/features/FeaturePageLayout';

export default function Umsatzsteuer(): ReactElement {
  return (
    <FeaturePageLayout
      badge="Steuern"
      title="Umsatzsteuervoranmeldung mit einem Klick"
      subtitle="Saldify berechnet Ihre Umsatzsteuer automatisch und erstellt die UStVA vorausgefüllt. Übermitteln Sie direkt ans Finanzamt – per ELSTER-Schnittstelle."
      heroImage="/screenshots/app-steuern.webp"
      heroImageAlt="Umsatzsteuer-Voranmeldung in Saldify, bereit zur Übermittlung an ELSTER"
      features={[
        {
          title: 'Automatische Berechnung',
          description: 'Umsatzsteuer und Vorsteuer werden aus Ihren Buchungen automatisch ermittelt.',
        },
        {
          title: 'ELSTER-Integration',
          description: 'Übermitteln Sie die UStVA direkt aus Saldify ans Finanzamt.',
        },
        {
          title: 'Vorausgefüllte Formulare',
          description: 'Alle Felder sind bereits ausgefüllt – Sie müssen nur noch prüfen und absenden.',
        },
        {
          title: 'Fristenerinnerung',
          description: 'Saldify erinnert Sie rechtzeitig an die Abgabefristen.',
        },
        {
          title: 'Korrektur-Meldungen',
          description: 'Bei Fehlern können Sie einfach eine korrigierte Meldung erstellen.',
        },
        {
          title: 'Archivierung',
          description: 'Alle abgegebenen Meldungen werden GoBD-konform archiviert.',
        },
      ]}
      sections={[
        {
          title: 'UStVA erstellen in 3 Schritten',
          description: 'Wählen Sie den Meldezeitraum, prüfen Sie die automatisch berechneten Werte und übermitteln Sie per Klick. Die Bestätigung vom Finanzamt erhalten Sie direkt in Saldify.',
          bullets: [
            'Zeitraum auswählen (Monat/Quartal)',
            'Berechnete Werte prüfen',
            'Mit ELSTER-Zertifikat übermitteln',
            'Empfangsbestätigung archivieren',
          ],
          imageSide: 'right',
        },
        {
          title: 'Alle Steuersätze im Griff',
          description: 'Egal ob 19%, 7% oder Reverse Charge – Saldify kennt alle deutschen Steuersätze und wendet sie automatisch an. Auch innergemeinschaftliche Lieferungen werden korrekt behandelt.',
          bullets: [
            'Automatische Steuersatz-Erkennung',
            'Reverse Charge für B2B-EU',
            'Steuerfreie Ausfuhrlieferungen',
            'Differenzbesteuerung möglich',
          ],
          imageSide: 'left',
        },
        {
          title: 'Zusammenfassende Meldung',
          description: 'Für innergemeinschaftliche Lieferungen erstellt Saldify automatisch die Zusammenfassende Meldung (ZM) und übermittelt sie ans Bundeszentralamt für Steuern.',
          bullets: [
            'Automatische Erkennung von EU-Lieferungen',
            'Prüfung der USt-IdNr. Ihrer Kunden',
            'Quartals- oder Monatsabgabe',
            'Direkte Übermittlung ans BZSt',
          ],
          imageSide: 'right',
        },
      ]}
      ctaTitle="Umsatzsteuer automatisieren"
      ctaDescription="Sparen Sie Zeit bei der Steuererklärung und vermeiden Sie Fehler durch automatische Berechnung."
    />
  );
}
